<template>
<el-tree
  v-loading="isLoading"
  :data="treeData"
  :props="orgProps"
  :load="load"
  node-key="id"
  ref="orgTree"
  lazy
  :highlight-current="true"
  @node-click="handleNodeClick">
</el-tree>
</template>
<script>
import { SETTING_EMPLOYEE_ORG_FIND_TREE } from '@/store/mutation-types'
import {mapState} from "vuex";

export default {
  props:{
    showStatus:Boolean,
  },
  data() {
    return {
      treeData: [],
      isLoading: false,
      rootResolve:'',
      rootNode:{},
      orgProps: {
        label: 'name',
        isLeaf: function(data){
          return !data.children
        }
      }
    }
  },
  computed:{
    ...mapState("app",["currentUser"])
  },
  created() {
  },
  mounted() {
  },
  watch:{
    showStatus(){
      this.treeData=[];
      this.load(this.rootNode,this.rootResolve)
    }
  },
  methods: {
    load({ level, data }, resolve) {
      this.isLoading = true
      /* 初始化第一级树节点 */
      let status=this.showStatus?0:1;
      if (level === 0) {
        this.rootNode={level,data}
        this.rootResolve=resolve;
        this.$store.dispatch(SETTING_EMPLOYEE_ORG_FIND_TREE, {
          parentId: this.currentUser.tenancyCode,
          status
        }).then(result => {
          this.treeData=result
        }).finally(()=>{
          this.isLoading = false
        })
      } else {
        /* 获取树下级节点 */
        this.$store.dispatch(SETTING_EMPLOYEE_ORG_FIND_TREE, {
          parentId: data.id,
          status
        }).then(result => {
          resolve(result)
        }).finally(()=>{
          this.isLoading = false
        })
      }
    },
    /* 监听树点击事件,并抛出 change 事件 */
    handleNodeClick(data) {
      this.$emit('change', data)
    }
  }
}
</script>
